t = require('views/internal/teacup-with-helpers')('popover_set_list_limit')

module.exports = t.renderable ({ limit }) ->
  t.div ->
    t.label ->
      t.format 'maximum-cards'
      t.input '.set-list-limit.js-autofocus.js-list-limit-input', {
        name: 'list-limit'
        min: 0,
        max: 5000,
        placeholder: t.l('no-limit-set'),
        type: 'number',
        value: limit
      }
    t.p '.quiet', ->
      t.format 'highlight-this-list-if-the-number-of-cards-in-it-passes-this-limit'
    t.input '.primary.wide.js-submit', { type: 'submit', value: t.l('save') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_set_list_limit.coffee